export default __webpack_public_path__ + "static/media/desk_preland_2.df5130f3.jpg";